var map = {
	"./3ddata.svg": 174,
	"./3djobs.svg": 175,
	"./3dmaintenance.svg": 176,
	"./3dpaas.svg": 177,
	"./Analytics.svg": 178,
	"./account.svg": 179,
	"./admin.svg": 180,
	"./anacreon.svg": 181,
	"./area51.svg": 182,
	"./autoflow.svg": 183,
	"./blacksea-portal.svg": 184,
	"./box.svg": 185,
	"./color-config.svg": 186,
	"./composer.svg": 187,
	"./da-vinci.svg": 188,
	"./devices.svg": 189,
	"./di.svg": 190,
	"./dscoop.svg": 191,
	"./epm-preflight-admin.svg": 192,
	"./epm-preflight.svg": 193,
	"./go3d.svg": 194,
	"./home.svg": 195,
	"./imposer.svg": 196,
	"./indigo-events.svg": 197,
	"./jobs.svg": 198,
	"./jobs_2.svg": 199,
	"./knowledge-zone.svg": 200,
	"./lkc.svg": 201,
	"./locr-maps.svg": 202,
	"./market-admin.svg": 203,
	"./marketplace.svg": 204,
	"./media-locator.svg": 205,
	"./myknowledge.svg": 206,
	"./packzalyzer.svg": 207,
	"./pc-reporter.svg": 208,
	"./ppc.svg": 209,
	"./press-security.svg": 210,
	"./print-beat.svg": 211,
	"./pwicfa.svg": 212,
	"./ready2print.svg": 213,
	"./reseller_portal.svg": 214,
	"./resource-manager.svg": 215,
	"./service-calls.svg": 216,
	"./sim.svg": 217,
	"./site-flow.svg": 218,
	"./softproof.svg": 219,
	"./substrate-manager.svg": 220,
	"./supplies_and_parts.svg": 221,
	"./takeback_menu.svg": 222,
	"./university.svg": 223,
	"./valid3d.svg": 224,
	"./wallart.svg": 225
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85;



//////////////////
// WEBPACK FOOTER
// ../~/@printos/gazelle/src/mini-apps/app-switcher/icons ../~/html-loader!\.svg$
// module id = 85
// module chunks = 0